export default __webpack_public_path__ + "static/media/calendarBlack.dcc5120d.svg";